/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SoftDeleteOrgData } from '../../models/soft-delete-org-data';

export interface SoftDeleteOrganization$Params {
  orgId: string;
      body: SoftDeleteOrgData
}

export function softDeleteOrganization(http: HttpClient, rootUrl: string, params: SoftDeleteOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, softDeleteOrganization.PATH, 'patch');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

softDeleteOrganization.PATH = '/api/v2/softDelete/{orgId}';
